module.exports = __webpack_public_path__ + "assets/mp3/audio9/lesson_2_06_audio3.mp3";